import { MessageUtils } from "./MessageUtils";

export class DialogUtils {

/**
 * Devuelve el diálogo con los botones y textos de la información
 * del correo institucional.
 * @returns dialogo.
 *
 */
 public static getDialogInfoCorreoInstitucional() {
    let data: any = {
        title: 'Correo electrónico institucional',
        text: MessageUtils.TEXT_INFO_CORREO_INSTITUCIONAL,
        acceptText: "Aceptar",
        showCancelButton: false,
      };

      return data;
}

/**
 * Devuelve el diálogo con los botones y textos de la información
 * del correo institucional.
 * @returns dialogo.
 */
 public static getDialogInfoCodigoPostal() {
  let data: any = {
      title: 'Código postal',
      text: MessageUtils.TEXT_INFO_CODIGO_POSTAL,
      acceptText: "Aceptar",
      showCancelButton: false,
    };

    return data;
}


/**
   * Devuelve un dialog de error del formulario.
   * @param message Mensaje customizado del error.
   * @return dialogo error.
   */
 public static getDialogErrorForm(message?:string) {

  let messageDialog = MessageUtils.TEXT_GENERIC_ERROR;

  if (message != null) {
    messageDialog = message;

  }

  let dialogFormError: any = {
    title: "Ha ocurrido un error.",
    text: messageDialog,
    acceptText: 'Aceptar',
    titleWarn: true,
    showAcceptButton: true,
    showLoginButton: false,
    showCloseButton: false,
    showInitButton: false,
    showCancelButton: false,
    acceptAppearance: 'raised',
    acceptColor: 'warn',
  }

  return dialogFormError;
 }

  /**
   * Devuelve un dialog de error customizable o genérico.
   * @param message Mensaje customizado del error.
   * @return dialogo error.
   */
 public static getDialogError(message?:string) {

  let messageDialog = MessageUtils.TEXT_GENERIC_ERROR;

  if (message != null) {
    messageDialog = message;

  }

  let dialogForm: any = {
    title: "Ha ocurrido un error en la solicitud.",
    text: messageDialog,
    acceptText: 'Aceptar',
    titleWarn: true,
    showAcceptButton: true,
    showCancelButton: false,
    acceptAppearance: 'raised',
    acceptColor: 'warn',
  }

  return dialogForm;
  }

  public static getDialogBajaUser() {
    let dialog: any = {
      title: "Solicitud de baja",
      text: "Si pulsas “Aceptar” tu usuario será dado de baja en el sistema y ya no podrás disfrutar de las ventajas del Carnet Universitario Digital.",
      acceptText: "Aceptar",
      cancelText: "Cancelar",
      titleWarn: true,
      showAcceptButton: true,
      acceptAppearance: 'raised',
      cancelColor: 'warn',
      initColor: 'primary',
    };

    return dialog;
  }

  /**
   * Devuelve un dialog de confirmación de cancelar un formulario.
   * @returns dialogo.
   */
  public static getDialogCancelForm() {
    let dialog: any = {
      title: "Aviso",
      text: "Si continúa no se guardarán los datos modificados y volverá a la pantalla de autenticación. ¿Desea continuar?",
      acceptText: "Sí",
      cancelText: "No",
      cancelColor: 'warn',
      titleWarn: true,
      showCloseButton: true,
    };

    return dialog;
  }

  /**
   * Devuelve un dialog de enviar un email o no.
   * @param error Error de la petición.
   * @returns dialogo.
   */
   public static getDialogLoginEmail(error) {
    let dialog: any = {
      title: "Aviso",
      text: error,
      acceptText: "Enviar email",
      cancelText: "Cancelar",
      acceptColor: 'warn',
      titleWarn: true,
      showCloseButton: true,
    };

    return dialog;
  }


  /**
   * Devuelve un dialog de las condiciones de acceso.
   * @returns dialogo.
   */
  public static getDialogCondiciones() {
    let dialogCondiciones: any = {
      title: "Condiciones",
      text: MessageUtils.TITLE_ACCESS_CONDITIONS,
      acceptText: "Aceptar",
      showCancelButton: false,
    };

    return dialogCondiciones;
  }

  /**
   * Devuelve un dialog informativo sobre revisar email.
   * @returns dialogo.
   */
  public static getDialogRevisarEmail() {
    let dialogEmail: any = {
      title: "Confirmación de usuario",
      text: MessageUtils.TEXT_CONFIRM_EMAIL,
      acceptText: "Aceptar",
      showCancelButton: false,
      acceptColor: 'warn',
      titleWarn: true,
      showCloseButton: true,
    };

    return dialogEmail;
  }

  /**
   * Devuelve un dialog informativo sobre el envío de email al no estar actualizado el formulario.
   * @returns dialogo.
   */
   public static getDialogNotSaveSendEmail() {
    let dialogEmail: any = {
      title: "Recordatorio",
      text: "Si has hecho algún cambio, guarda los datos antes de enviar el correo o se enviará desactualizado.",
      acceptText: "Enviar correo",
      cancelText: "Cancelar",
      acceptColor: 'warn',
      titleWarn: true,
      showCloseButton: true,
    };

    return dialogEmail;
  }

  /**
   * Devuelve un dialog informativo sobre el email de descargar del carnet.
   * @returns dialogo.
   */
   public static getDialogSendEmailDownloadCarnet() {
    let dialogEmail: any = {
      title: "Correo enviado.",
      text: "El Carnet Universitario ha sido enviado a la/s dirección/es de correo indicadas.",
      acceptText: "Aceptar",
      acceptColor: 'warn',
      showCancelButton: false,
      titleWarn: true,
    };

    return dialogEmail;
  }

  /**
   * Devuelve un dialog informativo sobre el guardado genérico de datos.
   * @returns dialogo.
   */
   public static getDialogSave() {
    let dialogSave: any = {
      title: "Cambios guardados.",
      text: "Los cambios han sido guardados exitosamente.",
      acceptText: "Aceptar",
      acceptColor: 'warn',
      showCancelButton: false,
      titleWarn: true,
    };

    return dialogSave;
  }

  /**
   * Devuelve un dialog informativo sobre revisar email para acceder al formulario de los datos del usuario.
   * @returns dialogEmail.
   */
   public static getDialogLogin() {
    let dialogEmail: any = {
      title: "Revisa tu correo electrónico.",
      text: "Para poder acceder a la aplicación, revisa tu correo electrónico y sigue las instrucciones.",
      acceptText: "Aceptar",
      acceptColor: 'warn',
      showCancelButton: false,
      titleWarn: true,
      showCloseButton: true,
    };

    return dialogEmail;
  }

  /**
   * Devuelve un dialog de la política de privacidad.
   * @returns dialogo.
   */
  public static getDialogPrivacy() {
    let dialogPrivacy: any = {
      title: "Política de privacidad",
      text: MessageUtils.TEXT_PRIVACY,
      acceptText: "Estoy de acuerdo",
      cancelText: "No estoy de acuerdo",
      titleWarn: true,
      acceptColor: 'warn',
      showCloseButton: true,
    };

    return dialogPrivacy;

  }

  /**
   * Devuelve un dialog confirmando que el email ha sido verificado.
   * @returns dialogo.
   */
   public static getDialogConfirmEmail() {
    let dialogEmail: any = {
      title: MessageUtils.TITLE_INFO,
      text: MessageUtils.TEXT_CONFIRM_EMAIL,
      acceptText: "Vale",
      showCancelButton: false,
      titleWarn: true,
      acceptColor: 'warn',
      showCloseButton: true,
    };

    return dialogEmail;

  }

  /**
   * Devuelve un dialog confirmando la baja de usuario.
   * @returns dialogo.
   */
   public static getDialogConfirmBaja() {
    let dialogBaja: any = {
      title: MessageUtils.TITLE_INFO,
      text: MessageUtils.TEXT_CONFIRM_BAJA,
      acceptText: "Vale",
      showCancelButton: false,
      titleWarn: true,
      acceptColor: 'warn',
      showCloseButton: true,
    };

    return dialogBaja;

  }

  /**
   * Devuelve un dialog indicando que el link ya no está disponible.
   * @returns dialogo.
   */
   public static getDialogLinkNotAvailable() {
    let dialogLink: any = {
      title: MessageUtils.TITLE_INFO,
      text: MessageUtils.LINK_NOT_AVAILABLE,
      acceptText: "Vale",
      showCancelButton: false,
      titleWarn: true,
      acceptColor: 'warn',
      showCloseButton: true,
    };

    return dialogLink;

  }

  /**
   * Devuelve un dialog de error sobre el pkpass del carnet universitario.
   * @returns dialogo.
   */
   public static getDialogPkpassInvalid() {
    let dialogEmail: any = {
      title: "Ha ocurrido un error",
      text: MessageUtils.PKPASS_INVALID,
      acceptText: "Aceptar",
      acceptColor: 'warn',
      showCancelButton: false,
      titleWarn: true,
    };

    return dialogEmail;
  }
}
